import { render } from "./SleepSectionChart.vue?vue&type=template&id=47c0bf36&scoped=true"
import script from "./SleepSectionChart.vue?vue&type=script&lang=js"
export * from "./SleepSectionChart.vue?vue&type=script&lang=js"

import "./SleepSectionChart.vue?vue&type=style&index=0&id=47c0bf36&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c0bf36"]])

export default __exports__